document.addEventListener('DOMContentLoaded', function() {
    var searchButton = document.querySelector('.search-button');
    var searchForm = document.querySelector('.searchform');
    var searchBG = document.querySelector('.search-bg');

    // Toggle search form and background visibility on search button click
    searchButton.addEventListener('click', function(event) {
        event.preventDefault(); // Prevent default action if necessary
        if (searchForm.style.display === 'none' || searchForm.style.display === '') {
            searchForm.style.display = 'block';
            searchBG.style.display = 'block';
        } else {
            searchForm.style.display = 'none';
            searchBG.style.display = 'none';
        }
    });

    // Hide both search form and background when clicking on the background
    searchBG.addEventListener('click', function() {
        searchForm.style.display = 'none';
        searchBG.style.display = 'none';
    });
});